module.exports = __webpack_public_path__ + "img/assignment_ind.537dd374.svg";